export { ColorUtils } from './utils/ColorUtils';
export { Cookie } from './utils/CookieUtils';
export { CurrencyUtils } from './utils/CurrencyUtils';
export { DateUtils } from './utils/DateUtils';
export { DeviceUtils } from './utils/DeviceUtils';
export { Dom, $$ } from './utils/Dom';
export { DomUtils } from './utils/DomUtils';
export { EmailUtils } from './utils/EmailUtils';
export { HashUtils } from './utils/HashUtils';
export { HighlightUtils, StringAndHoles } from './utils/HighlightUtils';
export { HTMLUtils } from './utils/HtmlUtils';
export { KEYBOARD, KeyboardUtils } from './utils/KeyboardUtils';
export { LocalStorageUtils } from './utils/LocalStorageUtils';
export { OSUtils, OS_NAME } from './utils/OSUtils';
export { PopupUtils } from './utils/PopupUtils';
export { QueryUtils } from './utils/QueryUtils';
export { StreamHighlightUtils } from './utils/StreamHighlightUtils';
export { StringUtils } from './utils/StringUtils';
export { TimeSpan } from './utils/TimeSpanUtils';
export { Utils } from './utils/Utils';
export { UrlUtils } from './utils/UrlUtils';



// WEBPACK FOOTER //
// ./src/UtilsModules.ts